module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search_location"
  }, [_c('div', {
    staticClass: "first-row"
  }, [_c('i', {
    staticClass: "material-icons clear-icon",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('div', {
    staticClass: "clear-btn pointer",
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.search_loc.query_location),
      expression: "$store.state.search_loc.query_location"
    }],
    staticClass: "search-location-dropdown",
    attrs: {
      "data-dropup-auto": "false"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.search_loc, "query_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.query_location,
        _vm.goToRoute(_vm.$store.state.search_loc.query_location)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Barcelona")]), _vm._v(" "), _c('option', [_vm._v("Berlin")]), _vm._v(" "), _c('option', [_vm._v("Copenhagen (København)")]), _vm._v(" "), _c('option', [_vm._v("Florence (Firenze)")]), _vm._v(" "), _c('option', [_vm._v("Lisbon (Lisboa)")]), _vm._v(" "), _c('option', [_vm._v("London")]), _vm._v(" "), _c('option', [_vm._v("Los Angeles")]), _vm._v(" "), _c('option', [_vm._v("Madrid")]), _vm._v(" "), _c('option', [_vm._v("Milan (Milano)")]), _vm._v(" "), _c('option', [_vm._v("New York")]), _vm._v(" "), _c('option', [_vm._v("Paris")]), _vm._v(" "), _c('option', [_vm._v("Porto")]), _vm._v(" "), _c('option', [_vm._v("Rome (Roma)")]), _vm._v(" "), _c('option', [_vm._v("San Francisco")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-more-container"
  }, [_c('div', {
    staticClass: "filter-header-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("Select a filter to limit results")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f8ff484","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search_locations.vue
// module id = 845
// module chunks = 12